module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.c0b8804a.woff";